import { onMounted, onUnmounted, ref } from "vue";

type Callback = () => void;
export function useRegister(cb: (signal: AbortSignal) => Callback | null) {
  const controller = new AbortController();
  const clean = ref<Callback | null>(null);
  onMounted(() => {
    clean.value = cb(controller.signal);
  });
  onUnmounted(() => {
    controller.abort();
    clean.value?.();
  });
}
